<template>
  <div class="table-overflow-wrapper">
    <div class="topic-wrapper overflow-shadow user-select-none float-left" ref="topicWrapper">
      <div class="topic stock-name">{{stockName}}</div>
      <div
        class="topic"
        v-for="(topicElem,index) in topics"
        :key="index"
        :id="topicElem"
        :class="{'mouse-hover':checkRowHover(topicElem),'sub-topic':checkSubTopic(topicElem),'first-sub-topic':checkSubTopic(topicElem)}"
        @mouseover="mouseOver(topicElem)"
        @mouseleave="mouseLeave"
        v-on:click="openChart(rawData, topicElem)"
      >
        <div class="topic-inside" v-html="getDataName(topicElem)"></div>
        <div class="chart-icon">
          <i class="fas fa-external-link-alt"></i>
        </div>
      </div>
    </div>

    <div
      class="content-wrapper user-select-none"
      :class="{blur : blur}"
      ref="contentWrapper"
      @scroll="onScroll"
      @mousedown="onMousedown"
      @mouseup="onMouseup"
      @mousemove="onMousemove"
    >
      <div class="content" ref="content">
        <div class="timeline-wrapper">
          <div class="year" v-for="year in timeline" :key="year">{{deleteRecentString(year)}}</div>
        </div>
        <div
          class="data-wrapper"
          v-for="(dataElem,index) in financialData"
          :key="index"
          :class="{'mouse-hover':checkRowHover(index),'sub-topic':checkSubTopic(index),'first-sub-topic':checkSubTopic(index)}"
          @mouseover="mouseOver(index)"
          @mouseleave="mouseLeave"
        >
          <div
            class="data-each"
            v-for="(elemEach,col) in dataElem"
            :key="col"
          >{{checkFormat(elemEach, index)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventHub from "../global/Event-hub.js";
import { mapActions } from "vuex";
// import TwoToggle from "../stock-quote/TwoToggle";
import * as dataLayer from "../../../utils/data-layer";

// import configStock from "../../../../src/config-financial-card.json";

var configStock = require("../../../assets/json/config-financial-card.json");
export default {
  name: "table-overflow",
  data() {
    return {
      rowHover: null,
      // Mouse Event
      mouseDown: false,
      mousePositionX: null
    };
  },
  props: {
    toggleQorY: {
      type: Number
    },
    stockName: {
      type: String,
      required: true
    },
    rawData: {
      type: Object,
      required: true
    },
    rawName: {
      type: String,
      required: true
    },
    emitScrolling: {
      type: Boolean,
      default: false
    },
    listenScrolling: {
      type: Boolean,
      default: false
    },
    scrollRightToEnd: {
      type: Boolean,
      default: true
    },
    dragScroll: {
      type: Boolean,
      default: true
    },
    dragCoefficient: {
      type: Number,
      default: 0.2
    },
    blur: {
      type: Boolean,
      required: false,
      default: true
    },
    sectionID: {
      type: String,
      default: ""
    }
  },
  watch: {
    $route: async function() {
      if (this.scrollRightToEnd) {
        setTimeout(() => {
          this.scrollToRightEnd();
        }, 500);
      }
    }
  },
  methods: {
    ...mapActions("stock", ["showStockChartModal"]),
    openChart(data, topic) {
      // push to datalayer
      dataLayer.clickStockChart({
        sectionID: this.sectionID,
        thName: this.getDataName(topic),
        enName: topic
      });

      /* push router parameter 
        - raw name: growthRateData
        - stockName
        - name: this.getDataName(topic),
        - timeframe: this.toggleQorY,
        - sectionID: this.sectionID


        solution
         - this.findStockQuote(this.$route.query.name);
         - getter -> getStockQuote
         - getStockQuote.ID to get getFinancialCardByCardName
         - send data to showStockChartModal
      */
      this.$router.push({
        name: "miniapp-stockchart",
        query: {
          graph_name: this.rawName,
          stock_name: this.stockName,
          topic
          // name: this.getDataName(topic),
          // timeframe: this.toggleQorY,
          // sectionID: this.sectionID
        }
      });
      // Open Modal
      this.showStockChartModal({
        data: data,
        topic: topic,
        stock: this.stockName,
        name: this.getDataName(topic),
        timeframe: this.toggleQorY,
        sectionID: this.sectionID
      });
    },
    // Handlers
    checkFormat(num, column) {
      let filter_data = configStock.financialCard.find(
        row => row.name && row.name == column
      );

      if (filter_data && filter_data.is_million_unit) {
        return num ? this.getNumberFormat((num / 1000).toFixed(2)) : "";
      } else if (filter_data && filter_data.is_percentage) {
        return num ? this.getNumberFormat((num * 100).toFixed(2)) : "";
      }
      return num ? this.getNumberFormat((num * 1).toFixed(2)) : "";
    },
    getNumberFormat(num) {
      var parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return parts.join(".");
    },
    getDataName(name) {
      let filter_data = configStock.financialCard.find(function(row) {
        return row.name && row.name == name;
      });
      if (filter_data) {
        return filter_data.name_th;
      }
      return "";
    },
    checkSubTopic(name) {
      let filter_data = configStock.financialCard.find(function(row) {
        return row.name && row.name == name;
      });
      if (filter_data) {
        if (filter_data.sub_topic == true) {
          return true;
        }
      }
      return false;
    },
    mouseOver(index) {
      this.rowHover = index;
    },
    mouseLeave() {
      this.rowHover = null;
    },
    onMousedown(e) {
      this.mousePositionX = e.clientX;
      this.mouseDown = true;
    },
    onMouseup() {
      this.mouseDown = false;
    },
    onMousemove(e) {
      if (this.dragScroll && this.mouseDown) {
        let contentWrapper = this.$refs.contentWrapper;
        contentWrapper.scrollLeft =
          contentWrapper.scrollLeft +
          (this.mousePositionX - e.clientX) * this.dragCoefficient;
      }
    },
    checkRowHover(index) {
      return index === this.rowHover;
    },
    onScroll() {
      // Check left end
      // let topicWrapper = this.$refs.topicWrapper;
      let contentWrapper = this.$refs.contentWrapper;
      if (contentWrapper && contentWrapper.scrollLeft < 10) {
        this.$refs.topicWrapper.classList.remove("overflow-shadow");
      } else {
        this.$refs.topicWrapper.classList.add("overflow-shadow");
      }

      // emit event
      if (this.emitScrolling) {
        let payload = {
          position: contentWrapper.scrollLeft
        };
        eventHub.$emit("table-overflow-scroll", payload);
      }
    },

    // Scrolling management
    scrollToRightEnd() {
      this.$refs.contentWrapper.scrollLeft = 5000;
    },
    onListenScrolling() {
      eventHub.$on("table-overflow-scroll", payload => {
        //check payload and size
        if ("position" in payload) {
          this.$refs.contentWrapper.scrollLeft = payload["position"];
        }
      });
    },
    keySort(data) {
      let keys = [];
      let obj = {};
      for (let q of Object.keys(data)) {
        let split = q.split("Q");
        if (split.length == 2) {
          obj[`${split[1]} Q${split[0]} `] = q;
        } else {
          obj[q] = q;
        }
      }

      for (let k in obj) {
        if (obj.hasOwnProperty(k)) {
          keys.push(k);
        }
      }
      keys.sort();
      return keys.map(q => {
        return obj[q];
      });
    },

    deleteRecentString(timelineKey) {
      let splitString = timelineKey.split("|");
      return splitString[splitString.length - 1];
    }
  },
  computed: {
    topics() {
      let data = this.rawData;
      if (!data || data.length === 0) return [];
      let arrTopic = [];
      let objData = this.toggleQorY == 1 ? data.qoq : data.yoy;

      arrTopic = Object.keys(objData);
      return arrTopic;
    },
    timeline() {
      let data = this.rawData;
      if (!data || data.length === 0) return [];
      let objData = this.toggleQorY == 1 ? data.qoq : data.yoy;
      let firstObj = objData[Object.keys(objData)[0]];
      var arrTimeline = [];
      if (firstObj) {
        arrTimeline = Object.keys(firstObj);
      }
      return arrTimeline;
    },
    financialData() {
      let data = this.rawData;
      if (!data || data.length === 0) return [];
      let objData = this.toggleQorY == 1 ? data.qoq : data.yoy;
      return objData;
    }
  },
  mounted() {
    var self = this;

    // Mission Control --------------------------------------------------------------------
    if (this.scrollRightToEnd) {
      setTimeout(function() {
        self.scrollToRightEnd();
      }, 500);
    }
    if (this.listenScrolling) {
      this.onListenScrolling();
    }
    //-------------------------------------------------------------------------------------
  },
  updated() {
    this.$emit("finished", true);
  },
  beforeDestroy() {
    eventHub.$off();
  }
};
</script>

<style lang='scss' scoped>
.blur {
  filter: blur(3px);
}
.float-left {
  float: left;
}
.action {
  cursor: pointer;
}

.table-overflow-wrapper {
  margin-top: 10px;
  // display: flex;
  border-bottom: 1px dotted #ffba16;

  .topic-wrapper {
    display: inline-block;
    width: $topic-wrapper-lg-width;
    &.overflow-shadow {
      box-shadow: 12px 0px 5px -3px rgba(232, 232, 232, 0.56);
    }

    .topic {
      position: relative;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      border-top: 1px solid $light-grey;
      font-size: 14px;
      font-weight: bold;
      color: $color-normal-text;

      .chart-icon {
        display: inline;
        position: absolute;
        right: 0px;
        top: 0px;
        line-height: 50px;
        border-left: 1px solid $light-grey;
        padding: 0px 10px;
        color: $text-grey-light;
      }

      &:first-of-type {
        border-top: 0px;
      }
      &:nth-of-type(2) {
        border-top: 0px;
      }
      .topic-inside {
        padding-right: 10px;
        width: 190px;
        line-height: 22px;
        vertical-align: middle;
        color: $color-normal-text;
        display: inline-block;
      }
      &.mouse-hover {
        background-color: $highlight-grey;
      }
      &:last-of-type {
        // border-bottom: 1px dotted $finno-orange;
      }
      &.stock-name {
        border-bottom: 1px dotted $finno-orange;
        height: 35px;
        line-height: 35px;
        color: $color-normal-text;
        font-family: DBHeaventRez;
        @extend %font-size-s;
        font-weight: normal;
      }
      &.sub-topic {
        padding-left: 10px;
        border-top: 1px dotted $grey;
        color: $medium-grey;
      }
      &.first-sub-topic {
        border-top: 0px;
        font-weight: normal;
      }
    }
  }
  .content-wrapper {
    overflow-x: auto;
    // display: -webkit-box;
    // display: -moz-box;
    // display: -ms-box;
    // display: box;
    display: flex;
    .content {
      width: max-content;
      cursor: move;
      .timeline-wrapper {
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        // color: $grey;
        text-align: right;
        border-bottom: 1px dotted $finno-orange;
        display: flex;
        .year {
          color: $color-normal-text !important;
          width: $content-lg-width;
          padding-right: 5px;
        }
      }
      .data-wrapper {
        border-top: 0.1px solid $light-grey;
        display: flex;
        color: $text-grey-light;
        &:first-of-type {
          border-top: 0px;
          background-color: violet;
        }
        &:nth-of-type(2) {
          border-top: 0px;
        }
        &:last-of-type {
          // border-bottom: 1px dotted $finno-orange;
        }
        &.mouse-hover {
          background-color: $highlight-grey;
        }
        &.sub-topic {
          border-top: 1px dotted $grey;
          color: $text-grey-light;
        }
        &.first-sub-topic {
          border-top: 0px;
        }
        .data-each {
          height: 50px;
          line-height: 50px;
          color: $color-normal-text;
          font-size: 14px;
          text-align: right;
          padding-right: 5px;
          width: $content-lg-width;
          &:last-of-type {
            background-color: $light-blue;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 580px) {
  .table-overflow-wrapper {
  }
}

@media screen and (max-width: 420px) {
  .table-overflow-wrapper {
    .topic-wrapper {
      width: $topic-wrapper-sm-width;
      .topic {
        font-size: 12px;
        height: 50px;
        line-height: 50px;
        &.stock-name {
          font-size: 10px;
        }

        .chart-icon {
          // display: none;
          border: none;
        }

        .topic-inside {
          line-height: 1.2;
          width: 100px;
        }
      }
    }
    .content-wrapper {
      .content {
        .timeline-wrapper {
          font-size: 11px;
          .year {
            width: $content-sm-width;
          }
        }
        .data-wrapper {
          .data-each {
            font-size: 12px;
            height: 50px;
            line-height: 50px;

            width: $content-sm-width;
          }
        }
      }
    }
  }
}
</style>
